function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/Upload/uploadFile.vue';
import * as dangaoActApi from '@/api/dangaoActApi';
export default {
  components: {
    UploadFile: UploadFile
  },
  data: function data() {
    return {
      fileUrl: null,
      loading: false,
      visible: false,
      initInfo: {},
      importFile: null
    };
  },
  methods: {
    openInit: function openInit(initInfo) {
      this.fileUrl = null;
      this.initInfo = _objectSpread({}, initInfo);
      this.loading = false;
      this.importFile = null;
      this.visible = true;
    },
    handerSubmit: function handerSubmit(form) {
      var _this = this;
      var formData = new FormData();
      formData.append('file', this.importFile);
      // formData.append('multipart', this.importFile);
      dangaoActApi.importProductRelative(formData).then(function (res) {
        _this.$message.success('导入成功！');
        _this.visible = false;
        _this.$emit('doRefresh');
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    // 导入
    beforeUpload: function beforeUpload(file) {
      this.importFile = file;
    }
  }
};